import Modal from "react-bootstrap/Modal";
import "../style/rightside.css";
import PaymentMethodComp from "./PaymentMethodComp";
import { useState } from "react";

const RecordPayment = (props) => {
    const [show, setshow] = useState(false);
    const [tenureday, settenureday] = useState(["Tradevu Account", "Cash"]);
    const [, setselectedmethod] = useState("");

  return (
      <>
          <PaymentMethodComp
              show={show}
              setshow={setshow}
              tenure={tenureday}
              selectedinvoice={props.selectedinvoice}
              setselectedmethod={setselectedmethod}
              settenureday={settenureday}
              record={props.record}
              setinvoices={props.setinvoices}
              currency={props.currency}
          />
          <Modal
              show={props.show}
              aria-labelledby="contained-modal-title-vcenter"
              centered
              className="addpaymentmodal"
              onHide={() => props.setshow(false)}
          >
              <Modal.Header>
                  <span
                      className="material-icons"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                          props.setshow(false);
                      }}
                  >
                      close
                  </span>
              </Modal.Header>
              <Modal.Body className="border-0 ">
                  <form action="">
                      <div
                          style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "32px",
                          }}
                      >
                          <h4
                              style={{
                                  color: "#101828",
                                  fontWeight: "700",
                                  fontSize: "18px",
                                  lineHeight: "24.3px",
                              }}
                          >
                              Record a new payment
                          </h4>

                          <button
                              placeholder="Method of payment"
                              className="!shadow-none border-0 outline-none p-4 py-3 rounded-[8px] gap-8 flex bg-[#ECEFF3] text-[#667085] tracking-[2%] leading-6 font-normal text-[16px]"
                              onFocus={() => {
                                  props.setshow(false);
                                  setshow(true);
                              }}
                          >
                            Select Method of payment
                          </button>
                          <button disabled={!show} className="bg-[#6F00FF] p-4 py-3 gap-2 outline-none border-0 rounded-[8px] text-white text-center text-sm leading-6 tracking-[2%] font-medium">
                              Record payment
                          </button>
                      </div>
                  </form>
              </Modal.Body>
          </Modal>
      </>
  );
};

export default RecordPayment;
